import { render } from "./SeatFareCard.vue?vue&type=template&id=a28d4fb8&scoped=true"
import script from "./SeatFareCard.vue?vue&type=script&lang=js"
export * from "./SeatFareCard.vue?vue&type=script&lang=js"

import "./SeatFareCard.vue?vue&type=style&index=0&id=a28d4fb8&scoped=true&lang=css"

import exportComponent from "/var/www/intercity.dev-jatri.jatritech.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a28d4fb8"]])

export default __exports__